import { render, staticRenderFns } from "./ShopMallPostSale.vue?vue&type=template&id=585f0b64&scoped=true&"
import script from "./ShopMallPostSale.vue?vue&type=script&lang=js&"
export * from "./ShopMallPostSale.vue?vue&type=script&lang=js&"
import style0 from "./ShopMallPostSale.vue?vue&type=style&index=0&id=585f0b64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f0b64",
  null
  
)

export default component.exports